const config = {
  siteKey: process.env.REACT_APP_RECAPTCHA_SITEKEY,
};

export const generateEmailToken = () =>
  new Promise((resolve) =>
    window.grecaptcha.ready(() => {
      resolve(window.grecaptcha.execute(config.siteKey, { action: 'email' }));
    })
  );

export const generateFundraiserCommentToken = () =>
  new Promise((resolve) =>
    window.grecaptcha.ready(() => {
      resolve(window.grecaptcha.execute(config.siteKey, { action: 'comment' }));
    })
  );
